import { render, staticRenderFns } from "./LevelLayout.vue?vue&type=template&id=f55a2bfe&scoped=true&"
import script from "./LevelLayout.vue?vue&type=script&lang=js&"
export * from "./LevelLayout.vue?vue&type=script&lang=js&"
import style0 from "./LevelLayout.vue?vue&type=style&index=0&id=f55a2bfe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f55a2bfe",
  null
  
)

export default component.exports